import React from 'react';
import {Button, Link} from "@material-ui/core";

const BBProfileCard = ({name, title, imgSrc, description}) => {
  return (
    <div className="profile-intro card shadow  border-0 text-center">

      <div className="pi-header">
        <div className="card-image layer">
          <img className="avatar-circle" src={imgSrc} alt="Team Member"/>
        </div>
      </div>
      <div className="pi-content">
        <h4>{name}</h4>
        <p>{title}</p>
        <p className="card-text">{description}</p>
      </div>
      <div className="pi-footer">
          {/*<a href={"mailto:support@breachbits.com"}>support@breachbits.com</a>*/}
          <span className="text-primary jr-link"><Link href={"mailto:support@breachbits.com?subject=BreachBits FAQ Request (from BreachBoard)"}><Button variant={"outlined"}>Email support@breachbits.com</Button></Link></span>
        {/*<div className="icons-wrapper">*/}
        {/*  <span className="icon facebook-icon jr-link">*/}
        {/*    <i className="zmdi zmdi-facebook zmdi-hc-fw zmdi-hc-lg"/>*/}
        {/*  </span>*/}

        {/*  <span className="icon twitter-icon jr-link">*/}
        {/*    <i className="zmdi zmdi-twitter zmdi-hc-fw zmdi-hc-lg"/>*/}
        {/*  </span>*/}

        {/*  <span className="icon linkedin-icon jr-link">*/}
        {/*    <i className="zmdi zmdi-linkedin zmdi-hc-fw zmdi-hc-lg"/>*/}
        {/*  </span>*/}
        {/*</div>*/}
      </div>
    </div>
  )
};

export default BBProfileCard;

